module.exports = __webpack_public_path__ + "static/media/ring2.c0346766.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/branding/default/audio/ring2.mp3
// module id = 612
// module chunks = 0